import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const serviceNow = defineConnector({
  identifier: "serviceNow",
  name: "ServiceNow",
  tagLine: "IT service management platform",
  logo,
  protocol: "http",
  tags: ["featured", "it", "security"],
  defaultUrlPattern: () => "https://.*\\.service-now\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your ServiceNow credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need your ServiceNow instance URL and credentials (username and password) with API access permissions.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Instance name",
          required: true,
          placeholder: "yourinstance",
          target: { kind: "configuration", field: "instance" },
          helperText:
            "Your ServiceNow instance name (e.g., yourinstance.service-now.com)",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instance }) =>
      `https://${instance}/api/now/table/sys_user?sysparm_limit=1`,
  },
  publicEnvVars: ({ instance }) => ({
    SERVICE_NOW_URL: instance ? `https://${instance}` : "",
  }),
});
